import {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useImperativeHandle,
} from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Form,
  useDispatch,
  useRouter,
  connect,
} from "../../atoms/DependencyHelper";
import Image from "../../atoms/image/image";
import DeliveryTitle from "../../atoms/deliveryTitle/DeliveryTitle";
import AuthenticationForm from "../../atoms/newLineForms/authenticationForm/AuthenticationForm";
import ErrorInformation from "../../atoms/errorInformation/ErrorInformation";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import {
  showSpinner,
  hideSpinner,
  replaceDropdownKeys,
  africaCountryCode,
  imagePrefix,
  urlPrefix,
  preValidationEligible,
  getPreValidationErrorType,
  getCookieValue,
  generateFormURL,
} from "../../../utils/helperServices";
import styles from "./CheckoutAuthentication.module.scss";
import microService from "../../../utils/microServices";
import ajaxService from "../../../utils/ajaxServices";
import labels from "../../../config/labels";
import errorMessages from "../../../config/errorMessages";
import {
  journeyType,
  CheckoutJourneyContext,
} from "../../../context/checkout-journey-context";

import { preValidationCheckService } from "../../../services/checkoutService";

import {
  SET_AUTHENTICATION_DETAILS,
  SET_LOOKUP_DETAILS,
  SET_SKIP_CREDIT_VETTING,
  ADD_CREDIT_PROFILE,
  SET_CREDIT_CHECK_AFFORD_DEAL,
} from "../../../Redux/actionTypes/index";

import { removeCreditCheckStates } from "../../../Redux/actions/checkoutAction";
import { deleteItemsFromCart } from "../../../Redux/actions/cartAction";

import * as Analytics from "../../../services/analyticsUtag";
import config from "../../../config";

import {
  Logger,
} from "../../../utils/logger";

const idTypesOptions = [
  {
    id: "SAID",
    label: "SA ID number",
  },
  {
    id: "PASSPORT",
    label: "Passport number",
  },
];

const CheckoutAuthentication = forwardRef(
  (
    {
      formContent,
      userLoggedIn,
      profileData,
      customerStatus,
      navigate,
      setShowSnackBar,
      setPageErr,
      profileLoading,
      isMiniApp,
      dealID,
      contractType,
      setJourneyStepTracker,
      authDetailsData,
      removeCreditCheckStates,
      features,
      deleteItemsFromCart,
      cartProducts,
      multicartFlag,
      handlePrimaryNxtLvlClick,
      selectedPreference,
    },
    ref
  ) => {
    const env = config.env;
    const legacyEnv = config.envConfigs[env].legacyEnv;
    const [dataFail, setDataFail] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { setJourney } = useContext(CheckoutJourneyContext);

    const [analytics, setAnalytics] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(true);

    const [countryTypesOptions, setCountryTypesOptions] = useState([]);
    const titleContents = formContent ? formContent.items : [];

    const numRegEx = RegExp(/^[0-9]*$/);
    const cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
    const passportNumberRegEx = RegExp(/^[A-Za-z0-9]*$/);
    const passportExpiryRegEx = RegExp(
      /^([0][1-9]|[12][0-9]|3[01])[\s][\/][\s]([0][1-9]|1[012])[\s][\/][\s]\d{4}$/
    );

    const cloneOfErrorMessages = JSON.parse(
      JSON.stringify(errorMessages.checkoutAuthentication.errors)
    );

    const dispatch = useDispatch();
    const router = useRouter();

    
  const newRedirectURL = (features?.shakaEnabled && features?.shakaEnabled !== undefined) ? 'checkout' : 'shopping';

    useImperativeHandle(ref, () => ({
      back: () => {
        Analytics.link({
          link_type: "o",
          link_name: `checkout: lets get started: ${customerStatus}: back to cart`,
        });
      },
    }));

    const [state, setState] = useState({
      validationsOn: {
        auth: true,
      },
      errorStatus: {
        auth: true,
      },
      validations: {
        auth: {
          idType: true,
          idNumber: true,
          cellNumber: true,
          passportNumber: false,
          passportExpiry: false,
          countryOrigin: false,
        },
      },
      fieldErrors: {
        auth: {
          idType: false,
          idNumber: false,
          cellNumber: false,
          passportNumber: false,
          passportExpiry: false,
          countryOrigin: false,
        },
        fail: false,
      },
      fieldValues: {
        auth: {
          idType: "SAID",
          idNumber: "",
          cellNumber: "",
          passportNumber: "",
          passportExpiry: "",
          countryOrigin: "",
        },
      },
      fieldErrorsMessage: cloneOfErrorMessages,
    });

    const {
      errorStatus,
      validations,
      fieldErrors,
      fieldValues,
      fieldErrorsMessage,
    } = state;

    const dealCartProduct = cartProducts.find(
      (cartProduct) =>
        cartProduct?.product?.is_deal_product === 1 &&
        cartProduct?.product?.__typename === labels.lbl_product_type_bundle
    );
    const cartId = getCookieValue("cart_id");
    const cartProductId = dealCartProduct?.id;

    /**
     * Return the selected id type
     *
     */
    function getIdType() {
      return fieldValues["auth"]["idType"] == "SAID" ? "id" : "passport";
    }

    useEffect(() => {
      // Add Event Listner to handle the click that happens outside
      document.addEventListener("mousedown", handleClickFaq);
      return () => {
        // Remove the event listner on component unmounting
        document.removeEventListener("mousedown", handleClickFaq);
      };
    }, []);

    const handleClickFaq = (e) => {
      if (e.target?.id == "see-faq-question-link") {
        $("html, body").animate(
          {
            scrollTop: $("#faqs").offset().top - 80,
          },
          1200
        );
      }

      if (e.target?.id == "main-account") {
        $("html, body").animate(
          {
            scrollTop: $("#main-account-nav").offset().top - 25,
          },
          1200
        );
      }
    };

    useEffect(() => {
      if (countryTypesOptions.length && customerStatus) {
        Analytics.view({
          page_event: "view",
          page_name: `checkout: lets get started: ${customerStatus}`,
          page_channel: "checkout",
          page_master_tab: "personal",
          authentication_id_type: "id",
          multicart_flag: multicartFlag ? true : false,
          ...Analytics.getProfileData(userLoggedIn, profileData, authDetailsData),
        });
      }
    }, [countryTypesOptions, customerStatus]);

    /**
     * Get the load lookup data
     */
    useEffect(() => {
      if (!profileLoading && customerStatus) {
        fetchLoadLookUpData();
      }
    }, [profileLoading, customerStatus]);

    const fetchLoadLookUpData = async () => {
      showSpinner();
      try {
        let responseData = await microService.get(
          "api",
          "loadLookup",
          null,
          false
        );

        if (responseData.response?.data?.result) {
          dispatch({
            type: SET_LOOKUP_DETAILS,
            payload: responseData.response.data.result,
          });
        }

        if (responseData.response?.data?.result?.COUNTRY) {
          setCountryTypesOptions(
            replaceDropdownKeys(
              responseData.response.data.result.COUNTRY,
              "description",
              "id",
              "country"
            ),
            hideSpinner()
          );
          setDataFail(false);
          setDataLoaded(true);
        } else {
          hideSpinner();
          const detailsParams = [
            `checkout: lets get started: ${customerStatus}`,
            "technical error",
            null,
          ];
          let detailsParamsErrCode, detailsParamsPreferences;
          if (responseData.error) {
            detailsParamsErrCode = `letsGetStarted_${responseData.error.status}`;
          } else {
            detailsParamsErrCode = labels.auth.errorCodes.api_time_out;
            detailsParamsPreferences = labels.checkout.lbl_preference_values;
          }
          detailsParams.unshift(detailsParamsErrCode);
          detailsParamsPreferences &&
            detailsParams.push(detailsParamsPreferences);
          fetchErrorDetails(...detailsParams);
        }
      } catch {
        if (multicartFlag) {
          setPageErr({
            type: "error",
            title: labels.checkout.lbl_invalid_attempt_title,
            desc: labels.checkout.lbl_invalid_attempt_desc,
            primaryLabel: "Continue",
            secondaryLabel: null,
            handlePrimaryClick: () => handlePrimaryClick(null, "continue"),
            imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
            pageName: pageName,
            pageErrorType: pageErrorType,
            additionalUtagData: additionalUtagData,
            dividerLine: true,
            ctaTitle: labels.checkout.lbl_select_preference,
            disablePrimary: true,
            preferences: labels.checkout.lbl_preference_values,
          });
        } else {
          setPageErr({
            type: "error",
            title: labels.auth.lbl_technical_error_title,
            desc: labels.auth.lbl_technical_error_desc,
            primaryLabel: "Call me back",
            secondaryLabel: "Exit checkout",
            handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
            handleSecondaryClick: () =>
              handleSecondaryClick(null, "exit checkout"),
            imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
            pageName: `checkout: lets get started: ${customerStatus}`,
            pageErrorType: "technical error",
          });
        }
        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      }
    };

    /**
     * Form input field blur event handler
     *
     * @usage call fieldValidationCheck function
     * @usage Set the state of form errorStatus
     * @usage Enable or disable form submit button
     * @call onBlur event
     */
    const handleBlur = async (event, val, form) => {
      event.persist();
      await fieldValidationCheck(event, val, form);

      errorStatus[form] = await checkFormError(form);
      setState({
        ...state,
        errorStatus,
      });

      if (fieldErrors.fail) {
        setSubmitDisabled(true);
        let name = event.target.name;
        let errMsg = fieldErrorsMessage[form][name];
        inlineAnalytics(errMsg);
      } else {
        checkErrorStatus();
      }
    };
    /**
     * Form input field change event handler
     *
     * @usage call updateFieldValues function
     * @usage Set the state of form fieldValues
     * @call onChange event
     */

    const handleChange = async (event, val, form) => {
      event.persist();
      let idType = getIdType();

      if (!analytics) {
        Analytics.link({
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
            "visitor_subscription_type",
          ]),
          page_form_event: "start",
          page_form_name: `checkout: lets get started: ${customerStatus}: form ${idType}`,
        });
        setAnalytics(true);
      }
      await updateFieldValues(event, val, form);
    };

    /**
     * Dropdown field reset handler
     *
     * @usage Set the default ID type (SAID)
     * @usage Remove the selected country
     */
    const handleReset = async (name, form) => {
      if (name == "idType") {
        if (fieldValues[form].idType !== "SAID") {
          validations[form].idNumber = true;
          validations[form].passportNumber = false;
          validations[form].passportExpiry = false;
          validations[form].countryOrigin = false;
          fieldValues[form].idType = "SAID";

          setState({
            ...state,
            validations,
            fieldValues,
          });

          errorStatus[form] = await checkFormError(form);
          setState({
            ...state,
            errorStatus,
          });

          if (errorStatus[form]) {
            setSubmitDisabled(true);
          } else {
            checkErrorStatus();
          }
        }
      } else if (name == "countryOrigin") {
        fieldValues[form].countryOrigin = "";

        if (
          state.validationsOn[form] &&
          state.validations[form].countryOrigin
        ) {
          fieldErrors[form].countryOrigin = true;
          if (fieldErrors[form].countryOrigin) {
            fieldErrorsMessage[form].countryOrigin =
              errorMessages.checkoutAuthentication.errors.auth.countryOrigin;
          }
          fieldErrors.fail = fieldErrors[form].countryOrigin;
        }

        if (fieldErrors.fail) {
          errorStatus[form] = true;
          setSubmitDisabled(true);
          let errMsg = fieldErrorsMessage[form].countryOrigin;
          inlineAnalytics(errMsg);
        }

        setState({
          ...state,
          errorStatus,
          fieldValues,
          fieldErrors,
          fieldErrorsMessage,
        });
      }
    };

    /**
     * Check input field validation
     *
     * @usage Set the state of form fieldErrors, fieldErrorsMessage
     */
    const fieldValidationCheck = async (event, val, form) => {
      const name = event.target.name;
      const value = val ? val : event.target.value;

      switch (name) {
        case "idNumber":
          if (state.validationsOn[form] && state.validations[form].idNumber) {
            if (value.length > 0) {
              if (!numRegEx.test(value)) {
                fieldErrors[form].idNumber = true;
                fieldErrorsMessage[form].idNumber =
                  errorMessages.checkoutAuthentication.idNumber.onlyNumber;
              } else if (value.length < 13) {
                fieldErrors[form].idNumber = true;
                fieldErrorsMessage[form].idNumber =
                  errorMessages.checkoutAuthentication.idNumber.minCharacters;
              } else {
                fieldErrors[form].idNumber = false;
              }
            } else {
              fieldErrors[form].idNumber = true;
              fieldErrorsMessage[form].idNumber =
                errorMessages.checkoutAuthentication.errors.auth.idNumber;
            }
            fieldErrors.fail = fieldErrors[form].idNumber;
          } else {
            fieldErrors[form].idNumber = false;
          }
          break;

        case "cellNumber":
          if (state.validationsOn[form] && state.validations[form].cellNumber) {
            if (value.length > 0) {
              if (!numRegEx.test(value)) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkoutAuthentication.cellNumber.onlyNumber;
              } else if (!cellPhoneRegEx.test(value)) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkoutAuthentication.cellNumber.startWith;
              } else if (africaCountryCode(value) && value.length < 11) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkoutAuthentication.errors.auth.cellNumber;
              } else if (value.length < 10) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkoutAuthentication.errors.auth.cellNumber;
              } else {
                fieldErrors[form].cellNumber = false;
              }
            } else {
              fieldErrors[form].cellNumber = true;
              fieldErrorsMessage[form].cellNumber =
                errorMessages.checkoutAuthentication.errors.auth.cellNumber;
            }
            fieldErrors.fail = fieldErrors[form].cellNumber;
          } else {
            fieldErrors[form].cellNumber = false;
          }
          break;

        case "passportNumber":
          if (
            state.validationsOn[form] &&
            state.validations[form].passportNumber
          ) {
            if (value.length > 0) {
              if (!passportNumberRegEx.test(value)) {
                fieldErrors[form].passportNumber = true;
                fieldErrorsMessage[form].passportNumber =
                  errorMessages.checkoutAuthentication.passportNumber.onlyValid;
              } else {
                fieldErrors[form].passportNumber = false;
              }
            } else {
              fieldErrors[form].passportNumber = true;
              fieldErrorsMessage[form].passportNumber =
                errorMessages.checkoutAuthentication.errors.auth.passportNumber;
            }
            fieldErrors.fail = fieldErrors[form].passportNumber;
          } else {
            fieldErrors[form].passportNumber = false;
          }
          break;

        case "passportExpiry":
          if (
            state.validationsOn[form] &&
            state.validations[form].passportExpiry
          ) {
            if (value.length > 0) {
              if (!passportExpiryRegEx.test(value)) {
                fieldErrors[form].passportExpiry = true;
                fieldErrorsMessage[form].passportExpiry =
                  errorMessages.checkoutAuthentication.passportExpiry.onlyValid;
              } else if (expireInSixMonths(value)) {
                fieldErrors[form].passportExpiry = true;
                fieldErrorsMessage[form].passportExpiry =
                  errorMessages.checkoutAuthentication.passportExpiry.sixMonthsExpiry;
              } else {
                fieldErrors[form].passportExpiry = false;
              }
            } else {
              fieldErrors[form].passportExpiry = true;
              fieldErrorsMessage[form].passportExpiry =
                errorMessages.checkoutAuthentication.errors.auth.passportExpiry;
            }
            fieldErrors.fail = fieldErrors[form].passportExpiry;
          } else {
            fieldErrors[form].passportExpiry = false;
          }
          break;

        case "countryOrigin":
          if (
            state.validationsOn[form] &&
            state.validations[form].countryOrigin
          ) {
            fieldErrors[form].countryOrigin = value == "" ? true : false;
            if (fieldErrors[form].countryOrigin) {
              fieldErrorsMessage[form].countryOrigin =
                state.fieldErrorsMessage.auth.countryOrigin;
            }
            fieldErrors.fail = fieldErrors[form].countryOrigin;
          } else {
            fieldErrors[form].countryOrigin = false;
          }
          break;
      }
      closeSnackBar();

      setState({
        ...state,
        fieldErrors,
        fieldErrorsMessage,
      });
    };

    /**
     * update input field values
     *
     * @usage Set the state of form validations, fieldValues
     */
    const updateFieldValues = async (event, val, form) => {
      const name = event.target.name;
      const value = val ? val : event.target.value;

      if (name == "idType") {
        if (value == "SAID") {
          validations[form].idNumber = true;
          validations[form].passportNumber = false;
          validations[form].passportExpiry = false;
          validations[form].countryOrigin = false;
        } else if (value == "PASSPORT") {
          validations[form].idNumber = false;
          validations[form].passportNumber = true;
          validations[form].passportExpiry = true;
          validations[form].countryOrigin = true;
        }
        fieldErrors.fail = false;

        //capture analytics user selects "passport" or "id"
        let idType = value == "SAID" ? "id" : "passport";
        selectionAnalytics("id type", idType);
      } else if (name == "countryOrigin") {
        //capture analytics user selects "country of origin"
        selectionAnalytics("country", value);
      }

      if (name == "passportExpiry") {
        //call function to add auto slash in date field
        fieldValues[form][name] = addAutoSlash(value);
      } else {
        fieldValues[form][name] = value;
      }
      setState({
        ...state,
        validations,
        fieldValues,
      });

      if (name == "idType") {
        let errForm = await checkFormError(form);

        if (errForm) {
          setSubmitDisabled(true);
        } else {
          setSubmitDisabled(false);
        }
      }
    };

    /**
     * Add slash to date field in dd/mm/yyyy format
     *
     * @call onChange event
     */
    const addAutoSlash = (value) => {
      if (/\D\/$/.test(value)) value = value.substr(0, value.length - 3);

      var values = value.split("/").map(function (v) {
        return v.replace(/\D/g, "");
      });

      if (values[0]) {
        values[0] = checkValue(values[0], 31, values[1] ? true : false);
      }
      if (values[1]) {
        values[1] = checkValue(values[1], 12, values[2] ? true : false);
      }

      var output = values.map(function (v, i) {
        //return v.length == 2 && i < 2 ? v + " / " : v;
        if (v.length == 2 && i < 2) {
          return v + " / ";
        } else if (v.length == 1 && i < 2 && values[i + 1]) {
          return v + " / ";
        } else {
          return v;
        }
      });

      return output.join("").substr(0, 14);
    };

    function checkValue(str, max, addZero) {
      if (str.charAt(0) !== "0" || str == "00" || addZero) {
        var num = parseInt(str);

        if (addZero && str.length == 1 && num !== 0) {
          str = num.toString();
        } else if (isNaN(num) || num <= 0 || num > max) {
          num = 1;
          str =
            num > parseInt(max.toString().charAt(0)) &&
            num.toString().length == 1
              ? "0" + num
              : num.toString();
        }
      }
      return str;
    }

    /**
     * Check if passport expires in 6 months
     *
     * @call onChange event
     */
    function expireInSixMonths(expiryDate) {
      let [date, month, year] = expiryDate.split(" / ");

      var cd = new Date();
      var ed = new Date(year, month - 1, date);
      // Add 6 months
      cd.setMonth(cd.getMonth() + 6);
      var ncd = new Date(cd.getFullYear(), cd.getMonth(), cd.getDate());

      if (ncd.getTime() > ed.getTime()) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * Set the analytics(link)
     *
     * @call when there is any form field error occured
     */
    const inlineAnalytics = (message) => {
      let idType = getIdType();
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "error",
        page_errors: message,
        page_form_name: `checkout: lets get started: ${customerStatus}: form ${idType}`,
        page_error_type: "form",
      });
    };

    /**
     * Set the selection analytics(link)
     *
     * @call when dropdown value change(country, idType)
     */
    const selectionAnalytics = (selectionType, value) => {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_tool_event: "use",
        page_tool_name: `checkout: lets get started: ${customerStatus}: ${selectionType}`,
        filter_query: value,
      });
    };

    /**
     * Check entire form error
     *
     * @usage check if any form field value is empty or not
     * @return true/false
     */
    function checkFormError(form) {
      var values = state.fieldValues[form];
      var errors = state.fieldErrors[form];
      var entries = Object.entries(state.validations[form]);

      if (state.validationsOn[form]) {
        for (const [key, value] of entries) {
          if ((values[key] == "" && value) || (errors[key] && value)) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    }

    /**
     * Check form error status
     *
     * @usage check if form error status is true or false
     * @usage Enable or disable form submit button
     */
    function checkErrorStatus() {
      var errValues = Object.values(state.errorStatus);

      for (const err of errValues) {
        if (err) {
          setSubmitDisabled(true);
          return;
        }
      }

      setSubmitDisabled(false);
    }

    /**
     * Form submit handler
     *
     * @usage call submitForm funtion when there is no error
     * @call onSubmit event
     */
    const handleSubmit = (event) => {
      event.preventDefault();
      event.persist();
      closeSnackBar();

      if (!dealID) {
        displaySnackBar(labels.checkout.lbl_no_deal_product);
        window.scrollTo(0, 0);
        event.stopPropagation();
      } else if (!state.errorStatus["auth"]) {
        Analytics.link({
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
            "visitor_subscription_type",
          ]),
          link_type: "o",
          link_name: `checkout: lets get started: ${customerStatus}: submit`,
        });
        submitForm();
      } else {
        displaySnackBar(
          labels.errors.lbl_form_not_submitted_fill_required,
          "form_level"
        );
        window.scrollTo(0, 0);
        event.stopPropagation();
      }
    };

    /**
     * Form submit request payload
     *
     * @usage map the key-value pair request
     */
    const mapFieldData = () => {
      return {
        docType: state.fieldValues["auth"].idType,
      };
    };

    /**
     * Form submit api call
     *
     * @usage submit the form with request payload
     */
    const submitForm = async () => {
      let inputObj = mapFieldData();
      let reqParams = [
        inputObj.docType == "SAID"
          ? state.fieldValues["auth"].idNumber
          : state.fieldValues["auth"].passportNumber,
      ];
      let reduxInfo = {
        information: null,
        idType: inputObj.docType,
        idNumber:
          inputObj.docType == "SAID"
            ? state.fieldValues["auth"].idNumber
            : state.fieldValues["auth"].passportNumber,
        msisdn: state.fieldValues["auth"].cellNumber,
        countryOrigin: state.fieldValues["auth"].countryOrigin,
        passportExpiry: state.fieldValues["auth"].passportExpiry,
      };

      if (state.fieldValues["auth"].idNumber !== authDetailsData?.idNumber) {
        removeCreditCheckStates(null);
      }

      try {
        showSpinner();

        let responseData = await microService.get(
          "api",
          "customerInformation",
          inputObj,
          true,
          reqParams
        );

        window.scrollTo(0, 0);
        hideSpinner();

        if (responseData.response?.data?.result) {
          reduxInfo.information = responseData.response.data.result;

          if (responseData.response.data.result?.customerType == "NEW") {
            //set newLine journey context if config is allowed
            if (features?.newLineEnabled) {
              setJourney(journeyType.newLine);

              if (state.fieldValues["auth"].idType == "SAID") {
                //navigate to XDS authentication or pre-validation failure
                preValidationCheck(journeyType.newLine, "xds");
              } else {
                //navigate to credit check or pre-validation failure
                preValidationCheck(journeyType.newLine, "creditCheck");
              }
            } else {
              router.push(
                `https://www${legacyEnv}.vodacom.co.za/cloud/${newRedirectURL}/order-summary?salesChannel=Contract&dealSheetNumber=${dealID}${isMiniApp ? "&miniApp=true" : ""}`
              );
            }
          } else {
            if (contractType == labels.deal_details.lbl_upgrade_deal_option) {
              //set upgrade journey context
              setJourney(journeyType.upgrade);
              setJourneyStepTracker(journeyType.upgrade);
              if (
                !responseData.response.data.result?.authorisedNumbers?.length
              ) {
                fetchErrorDetails(
                  `upgradecheckout_technical_error`,
                  `checkout: authentication: ${customerStatus}`,
                  `siebel`,
                  null,
                  labels.checkout.lbl_preference_values
                );
              } else {
                navigate("otp");
              }
            } else {
              //set addLine journey context if config is allowed
              if (features?.addLineEnabled) {
                setJourney(journeyType.addLine);
                setJourneyStepTracker(journeyType.addLine);

                //navigate to OTP
                navigate("otp");
              } else {
                router.push(
                  `https://www${legacyEnv}.vodacom.co.za/cloud/${newRedirectURL}/order-summary?salesChannel=Contract&dealSheetNumber=${dealID}${isMiniApp ? "&miniApp=true" : ""}`
                );
              }
            }
          }
        } else if (responseData?.error?.data?.responseCode) {
          const pageErrorType = getPreValidationErrorType(
            responseData.error.data.responseCode
          );
          fetchErrorDetails(
            responseData.error.data.responseCode,
            `checkout: lets get started: ${customerStatus}`,
            pageErrorType,
            null,
            responseData.error.data.responseCode == "LETSGETSTARTED_LEGACY"
              ? labels.checkout.lbl_preference_values
              : []
          );
        } else if (
          responseData?.error?.status === 400 &&
          responseData?.error?.data?.result?.message
        ) {
          displaySnackBar(responseData.error.data.result.message);
        } else {
          if (responseData?.error?.status) {
            fetchErrorDetails(
              `letsGetStarted_${responseData.error.status}`,
              `checkout: lets get started: ${customerStatus}`,
              "technical error",
              null,
              labels.checkout.lbl_preference_values
            );
          } else {
            fetchErrorDetails(
              labels.auth.errorCodes.api_time_out,
              `checkout: lets get started: ${customerStatus}`,
              "technical error",
              null,
              labels.checkout.lbl_preference_values
            );
          }
        }
      } catch {
        hideSpinner();
      } finally {
        //store the result in redux
        dispatch({
          type: SET_AUTHENTICATION_DETAILS,
          payload: reduxInfo,
        });
      }
    };

    const preValidationCheck = async (journey, page) => {
      showSpinner();
      let idNumber =
        state.fieldValues["auth"].idType == "SAID"
          ? state.fieldValues["auth"].idNumber
          : state.fieldValues["auth"].passportNumber;

      let results = await preValidationCheckService(
        state.fieldValues["auth"].idType,
        idNumber,
        dealID,
        journey
      );

      hideSpinner();

      if (results.responseCode) {
        dispatch({
          type: SET_SKIP_CREDIT_VETTING,
          payload: results.skipCreditVetting,
        });

        if (
          results.responseCode == "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE"
        ) {
          dispatch({
            type: ADD_CREDIT_PROFILE,
            payload: results.creditFilters,
          });
          dispatch({
            type: SET_CREDIT_CHECK_AFFORD_DEAL,
            payload: true,
          });
        } else {
          dispatch({
            type: SET_CREDIT_CHECK_AFFORD_DEAL,
            payload: false,
          });
        }

        if (preValidationEligible(results.responseCode)) {
          Analytics.link({
            ...Analytics.getUtagData([
              "page_name",
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
              "visitor_subscription_type",
            ]),
            page_form_event: "success",
            page_form_name: `checkout: lets get started: ${customerStatus}: form ${
              state.fieldValues["auth"].idType == "SAID" ? "id" : "passport"
            }`,
          });

          setJourneyStepTracker(journey);
          let newPage =
            page == "creditCheck" && results.skipCreditVetting
              ? "review"
              : page;
          navigate(newPage);
        } else {
          const pageErrorType = getPreValidationErrorType(results.responseCode);

          Logger.info(
            `Prevalidation check returned code ${results.responseCode}`,
            "CheckoutAuthentication",
            {
              TagErrorType: pageErrorType || "not returned",
              ServiceResponseCode: results.responseCode,
              response: JSON.stringify(results || {}),
              data: {
                idType: state.fieldValues["auth"].idType,
                idNumber,
                dealID,
                journey: journey,
              }
            },
            { preval_result_code: results.responseCode }
          );

          fetchErrorDetails(
            results.responseCode,
            `checkout: pre val: ${customerStatus}`,
            pageErrorType,
            "authentication_id_type",
            results.responseCode == "Approved_Conditions_Vetting_Outcome"
              ? labels.checkout.lbl_preference_approved_conditions_values
              : results.responseCode == "Declined_LeadNXT_LVL"
              ? labels.checkout.lbl_preference_values
              : []
          );
        }
      } else {

        fetchErrorDetails(
          `preValidation_${results.errors?.status}`,
          `checkout: pre val: ${customerStatus}`,
          "technical error",
          "authentication_id_type",
          labels.checkout.lbl_preference_values
        );

        Logger.error(
          "No pre validation response code returned",
          "CheckoutAuthentication",
          {
            response: JSON.stringify(results || {}),
            data: {
              idType: state.fieldValues["auth"].idType,
              idNumber,
              dealID,
              journey: journey,
            }
          }
        );
      }
    };

    /**
     * Get the error display data
     * @usage Redirect to checkout error with error details
     */
    const fetchErrorDetails = async (
      resultCode,
      pageName,
      pageErrorType,
      additionalUtagData = null,
      preferences = []
    ) => {
      const newResultCode = multicartFlag
        ? resultCode + "_multicart"
        : resultCode;

      try {
        showSpinner();
        const result = await ajaxService.httpGet(
          "drupalBaseUrl",
          "",
          "api",
          "errorResultDetails",
          [newResultCode]
        );

        let desc =
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML;
        let subDesc = null,
          subTitle = null;
        const declined_lead_next_level = "Declined_LeadNXT_LVL";

        if (resultCode == declined_lead_next_level) {
          desc =
            "You can still continue to purchase the other items you added to your cart";
          subTitle = result[0].resultHTML ? result[0].resultHTML : null;
          subDesc = result[0].resultText ? result[0].resultText : null;
        }

        setPageErr({
          type: "error",
          title: result[0].resultTitle,
          subTitle,
          desc,
          subDesc,
          primaryLabel:
            result[0].primaryEnabled === "Yes"
              ? result[0].primaryCTAText
              : null,
          primaryUrl:
            result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
          secondaryLabel:
            result[0].secondaryEnabled === "Yes"
              ? result[0].secondaryCTAText
              : null,
          secondaryUrl:
            result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
          handlePrimaryClick: (preferenceId) => {
            if (
              result[0].resultCode ===
                `${declined_lead_next_level}_Multicart` &&
              selectedPreference === "call-me-back"
            ) {
              handlePrimaryNxtLvlClick();
              return;
            }

            handlePrimaryClick(
              generateFormURL(
                result[0].primaryCTAURL,
                result[0].leadType,
                result[0].primaryCTAType,
                preferenceId
              ),
              result[0].primaryCTAText
            );
          },
          handleSecondaryClick: () =>
            handleSecondaryClick(
              generateFormURL(
                result[0].secondaryCTAURL,
                result[0].leadType,
                result[0].secondaryCTAType
              ),
              result[0].secondaryCTAText,
              resultCode
            ),
          imgUrl: result[0].icon,
          pageName: pageName,
          pageErrorType: pageErrorType
            ? pageErrorType
            : result[0].analyticTitle !== resultCode
            ? result[0].analyticTitle
            : "technical error",
          additionalUtagData: additionalUtagData,
          dividerLine: result[0].CTATitle != "" ? true : false,
          ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
          disablePrimary:
            multicartFlag && preferences.length > 0 ? true : false,
          preferences: multicartFlag ? preferences : [],
          defaultPreference:
            multicartFlag && result[0].primaryCTAURL?.includes("/checkout")
              ? "once-off"
              : null,
        });
        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      } catch {
        if (multicartFlag) {
          setPageErr({
            type: "error",
            title: labels.checkout.lbl_invalid_attempt_title,
            desc: labels.checkout.lbl_invalid_attempt_desc,
            primaryLabel: "Continue",
            secondaryLabel: null,
            handlePrimaryClick: (preferenceId) =>
              handlePrimaryClick(
                generateFormURL(
                  "/forms/ecommerce",
                  "pre_validation_checks",
                  "lead",
                  preferenceId
                ),
                "continue"
              ),
            imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
            pageName: pageName,
            pageErrorType: pageErrorType ? pageErrorType : "technical error",
            additionalUtagData: additionalUtagData,
            dividerLine: true,
            ctaTitle: labels.checkout.lbl_select_preference,
            disablePrimary: true,
            preferences: labels.checkout.lbl_preference_values,
          });
        } else {
          setPageErr({
            type: "error",
            title: labels.auth.lbl_technical_error_title,
            desc: labels.auth.lbl_technical_error_desc,
            primaryLabel: "Call me back",
            secondaryLabel: "Exit checkout",
            handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
            handleSecondaryClick: () =>
              handleSecondaryClick(null, "exit checkout"),
            imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
            pageName: pageName,
            pageErrorType: pageErrorType ? pageErrorType : "technical error",
            additionalUtagData: additionalUtagData,
          });
        }

        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      }
    };

    const handlePrimaryClick = (url, label) => {
      showSpinner();
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      const navigateUrl = url === "/" ? url : `${urlPrefix}${url}`;

      Analytics.link({
        link_type: "o",
        link_name: `${pageName}: ${label}`,
        page_name: `${pageName}`,
      });

      if (url) {
        if (label.includes(labels.mah_authentication.lbl_pay_my_bill)) {
          router.push(url).then(() => {
            hideSpinner();
          });
          return;
        }
        router.push(navigateUrl).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
          hideSpinner();
        });
      }
    };

    const handleSecondaryClick = async (url, label, resultCode) => {
      showSpinner();
      if (resultCode === "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE") {
        await deleteItemsFromCart(cartId, cartProductId);
      }
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      const navigateUrl = url === "/" ? url : `${urlPrefix}${url}`;

      Analytics.link({
        link_type: "o",
        link_name: `${pageName}: ${label}`,
        page_name: `${pageName}`,
      });

      if (url) {
        if (label.includes(labels.mah_authentication.lbl_pay_my_bill)) {
          router.push(url).then(() => {
            hideSpinner();
          });
          return;
        }

        router.push(navigateUrl).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/cart`).then(() => {
          hideSpinner();
        });
      }
    };

    const displaySnackBar = (message, level = "page_level") => {
      let idType = getIdType();
      setShowSnackBar({ visible: true, message: message });

      const pageAnalyticsData = {
        page_errors: message,
        page_error_type: "page",
      };

      if (level == "form_level") {
        pageAnalyticsData.page_form_event = "error";
        pageAnalyticsData.page_form_name = `checkout: lets get started: ${customerStatus}: form ${idType}`;
        pageAnalyticsData.page_error_type = "form";
      }

      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        ...pageAnalyticsData,
        link_type: "o",
        link_name: `checkout: lets get started: ${customerStatus}: submit`,
      });
    };

    const FormHandlerInformation = () => {
      if (dataFail) {
        return (
          <ErrorInformation
            desc="Would you like to try again?"
            onClickHandler={fetchLoadLookUpData}
            className={styles["error-container"]}
          />
        );
      } else {
        return <></>;
      }
    };

    const closeSnackBar = () => {
      setShowSnackBar({ visible: false, message: "" });
    };

    return (
      <>
        <CustomContainer className={`${styles["container"]}`}>
          {!dataFail && dataLoaded && (
            <>
              <CustomContainer className={styles["form-heading"]}>
                <Image
                  className={styles["icon"]}
                  img_path={`${imagePrefix}/assets/images/icon-auth.svg`}
                />
                Please provide your details below:
              </CustomContainer>
              <DeliveryTitle
                contents={titleContents}
                className={styles["standard-box"]}
                descClassName={styles["standard-box__desc"]}
                id={`checkout-authentication-standard-delivery`}
                iconType="info"
              />
              <Form
                noValidate
                className={styles["form"]}
                id="checkout-authentication-form"
                onSubmit={handleSubmit}
              >
                <AuthenticationForm
                  formName="auth"
                  fieldValues={state.fieldValues["auth"]}
                  fieldErrors={state.fieldErrors["auth"]}
                  fieldErrorsMessage={state.fieldErrorsMessage["auth"]}
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  onResetHandler={handleReset}
                  idTypesOptions={idTypesOptions}
                  countryTypesOptions={countryTypesOptions}
                />
                <CustomContainer className={styles["button-wrapper"]}>
                  <CTAButton
                    type="submit"
                    variant="solid grey"
                    disabled={submitDisabled}
                    className={styles["button"]}
                    id="checkout-authentication-form-submit"
                  >
                    Continue
                  </CTAButton>
                </CustomContainer>
              </Form>
            </>
          )}
          <FormHandlerInformation />
        </CustomContainer>
      </>
    );
  }
);

CheckoutAuthentication.propTypes = {
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  customerStatus: PropTypes.string,
  navigate: PropTypes.func,
  handlePrimaryNxtLvlClick: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    profileLoading: state.navDetails.isProfileLoading,
    isMiniApp: state.navDetails.isMiniApp,
    authDetailsData: state.checkoutDetails.authDetails,
    cartProducts: state.cartDetails.cartProductItems,
    selectedPreference: state.checkoutPageError.selected_preference,
  };
};

const mapDispatchToProps = {
  removeCreditCheckStates,
  deleteItemsFromCart,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(CheckoutAuthentication);
